// 城乡居民养老保险待遇申请——微信，主流程
const wxMainRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `retirement/wx/index${i + 1}`,
  name: `retirementWxIndex${i + 1}`,
  component: () => import(`@/views/society/retirement/wx/index${i + 1}.vue`)
}))

// 城乡居民养老保险待遇申请——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 17 }, (_, i) => ({
  path: `retirement/zfb/index${i + 1}`,
  name: `retirementZfbIndex${i + 1}`,
  component: () => import(`@/views/society/retirement/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 城乡居民养老保险待遇申请——微信，开始
    ...wxMainRoutes,

    // 城乡居民养老保险待遇申请——支付宝，主流程
    ...zfbMainRoutes
  ]
}
